import React from "react";
import {Page} from "../../common/Page";


export const LoggedOutPage = () => {

  return <Page title={"Logged out"}>
    <p>You've been logged out.</p>
    <p>Want to get back in? <a href={'/login'}>Log in</a>.</p>
  </Page>;
}